import { serviceWrapper } from 'shared_js/helpers/api';
import interfaces from './interface';

export default serviceWrapper(interfaces, 'xhrNeo');
